<template>
  <modal :is-show="isShowPosterModal" @hideModal="hidePosterModal">
    <div class="poster-modal">
      <div class="head">
        <span>分享海报</span>
      </div>
      <div class="img">
        <img :src="activityConfig.shareImgUrl" />
      </div>
      <div class="text">
        <span>长按保存图片</span>
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from './Modal'
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'PosterModal',
    components: {
      Modal
    },
    computed: {
      ...mapState(['isShowPosterModal', 'activityConfig']),
    },
    methods: {
      ...mapMutations(['hidePosterModal']),
    }
  }
</script>

<style scoped lang="less">
  .poster-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 6rem;
    background: #fff;
    transform: translate(-50%, -50%);
    .head {
      position: relative;
      height: 0.92rem;
      color: #fff;
      font-weight: 400;
      line-height: 0.92rem;
      text-align: center;
      background: linear-gradient(180deg, #f84c5b 0, #f73042 100%);
    }
    .img {
      margin: 0 auto;
      padding-top: 0.48rem;
      width: 6rem;
      img {
        display: block;
        margin: 0 auto;
        width: 60%;
      }
    }
    .text {
      margin-top: 0.1rem;
      height: 0.8rem;
      background: #f4f9f3;
      color: #000;
      text-align: center;
      line-height: 0.8rem;
    }
  }
</style>
